import { Component, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { BehaviorSubject, Observable, of, fromEvent } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { catchError, finalize, tap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { projectConstants } from 'src/app/shared/constants/project-constants';
import { CreateLabelComponent } from '../create-label/create-label.component';
import { AccountUserService } from 'src/app/services/account-user.service';
import { ChangeLabelStatusComponent } from '../change-label-status/change-label-status.component';
import { Location } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-list-label',
  templateUrl: './list-label.component.html',
  styleUrls: ['./list-label.component.css']
})
export class ListLabelComponent implements OnInit, AfterViewInit {
  dataSource = new AccountUserDataSource(this.accountuserService);
  tableFilters = '';
  displayedColumns = ['label', 'displayName', 'Description', 'status'];
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild('go', {static: false}) go: ElementRef;
  selectedRowIndex = -1;
  showToolBar = false;
  collapsed;
  collapsedlcFilter;
  labelCount: any;
  scConfig: any = {};
  userTypes: any = [];
  screenHeight;
  screenWidth;
  showsaleschannel;
  small_device_display = false;
  salesfilter;
  accountTypes: any = [];
  salesChannelfilter;
  user: any;
  type: any;
  pageSize: number;
  pageNo: number;
  pageIndex: number;
  sales_type_statuses = projectConstants.SALES_TYPE_STATUSES;
  page_Number: any;
  labelDetails;
  constructor(
    private accountuserService: AccountUserService,
    private commonFilter: CommonfilterService,
    private locObj: Location,
    private commonfilterService: CommonfilterService,
    private dialog: MatDialog) {
    this.commonfilterService.getConfigData()
      .subscribe(res => {
        this.scConfig = res;
        this.userTypes = this.scConfig.userType;
      });
    this.onResize();
  }

  ngOnInit() {
    this.dataSource.loadLabels(this.tableFilters, 'false', 0, 100);
    this.getTotalCountByFilters(this.tableFilters);


  }
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
      this.small_device_display = true;
    } else {
      this.small_device_display = false;
    }
  }
  getTotalCountByFilters(filters) {
    this.accountuserService.getTotalCountByFilters(filters)
      .subscribe(res => {
        this.labelCount = res;
        // this.paginator.pageIndex = 0;
      });
  }
  ngAfterViewInit() {
    this.paginator.page
      .pipe(
        tap(() => this.loadLabelsPage())
      )
      .subscribe();

    fromEvent(this.go.nativeElement, 'click')
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.tableFilters = this.commonFilter.createfilterParams('Accountuser');
          this.getTotalCountByFilters(this.tableFilters);
          this.paginator.pageIndex = 0;
          this.loadLabelsPage();

        })
      )
      .subscribe();
  }
  createLabel() {
    const dialogreference = this.dialog.open(CreateLabelComponent, {
      width: '800px',
      data: { 'type': 'add' }
    });
    dialogreference.afterClosed().subscribe(result => {
      this.loadLabelsPage();
    });
   } 
   updateLabel() {
    const dialogreference = this.dialog.open(CreateLabelComponent, {
      width: '800px',
      data: {'type': 'edit', 'labels': this.labelDetails}
    });
    dialogreference.afterClosed().subscribe(result => {
      this.loadLabelsPage();
    });
   }
   changeStatus() {
    const dialogreference = this.dialog.open(ChangeLabelStatusComponent, {
      width: '800px',
      data: { 'labels': this.labelDetails }
    });
    dialogreference.afterClosed().subscribe(result => {
      this.selectedRowIndex = -1;
      this.showToolBar = false;
      this.loadLabelsPage();
    });
  }
  loadLabelsPage() {
    const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;
  
    this.dataSource.loadLabels(
  
      this.tableFilters,
      'false',
      count,
      this.paginator.pageSize);
  }
  goBacktoList() {
    // this.router.navigate(['../../../list'], { relativeTo: this.activatedRoute });
    this.locObj.back();
  }
  onRowClicked(labelDta) {
    this.selectedRowIndex = labelDta.label;
    this.labelDetails = labelDta;
    this.showToolBar = true;
  }
  // pageEvents(event: any) {
  //   this.pageIndex = event.pageIndex;
  // }
}
export class AccountUserDataSource implements DataSource<any> {

  private corporateSubject = new BehaviorSubject<any>([]);

  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor(private accountuserService: AccountUserService) {

  }
  connect(collectionViewer: CollectionViewer): Observable<any> {
     return this.corporateSubject.asObservable();

  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.corporateSubject.complete();
    this.loadingSubject.complete();
  }

  loadLabels( 
    filter,sortDirection, count, pageSize) {

  this.loadingSubject.next(true);

  this.accountuserService.getLabels(filter,sortDirection,
    count, pageSize).pipe(
     catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    )
    .subscribe(corporates => this.corporateSubject.next(corporates));
  }
}
